// In-memory session data cache.
// Replaces localStorage for the 8 large session-scoped keys to avoid QuotaExceededError.
// Data is sourced from / persisted to the database via /Session/SaveSessionJson and
// /Session/GetSessionJson. This module is purely an in-process staging area.
const _cache = new Map();

export const sessionCache = {
  get(key) {
    return _cache.get(key);
  },

  set(key, value) {
    _cache.set(key, value);
  },

  has(key) {
    return _cache.has(key);
  },

  delete(key) {
    _cache.delete(key);
  },

  clear() {
    _cache.clear();
  },

  keys() {
    return _cache.keys();
  },

  toObject() {
    return Object.fromEntries(_cache);
  },

  toFilteredObject(keys) {
    const result = {};
    for (const key of keys) {
      if (_cache.has(key)) {
        result[key] = _cache.get(key);
      }
    }
    return result;
  },
};
